import React from 'react'
import { Container, Nav, Navbar, NavDropdown } from "react-bootstrap";
import { BrowserRouter as Router, Switch, Route, useLocation } from "react-router-dom";
import Patients from './pacientesDash/main.patients'
import Citas from './citas/main.citas'
import Perfil from './perfil'
import Home from './home/home'
import icon from '../assets/Icon.png';
import { Footer, logout, myHospitals } from '../resources'
import { usuario } from '../resources'
import { Historial } from './historial';
import MainPacientes from './pacientes/main.pacientes';
import Escalas from '../escalas/escalasMenu';
import Ingresos from './ingresos/ingresos';
import { KetaminaPublic, DepresionQidsPublic, DepresionEspanolPublic, HeadachePublic, PostTraumaticoPublic, PostTraumaticoClinicoPublic, PostTraumaticoMX } from '../session/public_escalas_routes';
import Horarios from './horarios/horarios';
import EscalasEMT from '../doctorViews/expedientes/visitas-details/escalas-emt';
import HojaRegistroEMT from '../doctorViews/expedientes/visitas-details/hoja-registro-emt';
import PacientesNext from './pacientes-next';
import { CalendarOutlined, HomeOutlined, LogoutOutlined, UserOutlined } from '@ant-design/icons';
import RegisterPatient from './pacientes-next/register';

function Navigator() {
  const { pathname } = useLocation();
  return (
    <Navbar bg="primary" variant="dark" expand="lg" sticky="top">
      <Container>
        <Navbar.Brand href="/" style={{ fontFamily: 'Poppins' }}>
          <img src={icon} width="40" height="35" className="d-inline-block align-top" alt="Recreamed logo" style={{ marginRight: 8 }} />
          Re-Crea Med
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="main-navbar" />
        <Navbar.Collapse id="main-navbar">
          <Nav className="me-auto" activeKey={pathname}>
            <Nav.Link href="/" eventKey="/">
              <HomeOutlined style={{ marginRight: 4 }} /> Inicio
            </Nav.Link>
            <Nav.Link href="/pacientes" eventKey="/pacientes">
              <UserOutlined style={{ marginRight: 4 }} /> Pacientes
            </Nav.Link>
            <Nav.Link href="/citas" eventKey="/citas">
              <CalendarOutlined style={{ marginRight: 4 }} /> Citas
            </Nav.Link>
          </Nav>
          <Nav>
            <NavDropdown
              title={<><UserOutlined style={{ marginRight: 6 }} />{usuario.name.split(' ')[0]}</>}
              id="user-dropdown"
              align="end"
            >
              <NavDropdown.Item href="/perfil">Mi perfil</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item onClick={logout} style={{ color: '#dc3545' }}>
                <LogoutOutlined style={{ marginRight: 6 }} /> Cerrar sesión
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default function RecepcionApp() {

  return (
    <Router>

      <Navigator />

      <Switch>

        {/* Deprecated */}
        <Route path="/pacientesdash">
          <Patients />
        </Route>

        {/* Deprecated */}
        <Route path="/pacientes-old">
          <MainPacientes />
        </Route>
        <Route path="/pacientes">
          <PacientesNext />
        </Route>
        <Route path="/registrar-paciente">
          <RegisterPatient />
        </Route>

        <Route path="/citas">
          <Citas />
        </Route>

        {/* <Route path="/Recetas">
          <Recetas />
        </Route> */}

        <Route path="/perfil">
          <Perfil />
        </Route>

        <Route path="/historial">
          <Historial />
        </Route>

        <Route path="/balances">
          <Ingresos />
        </Route>

        <Route path="/horarios">
          <Horarios />
        </Route>

        {/* <Route path="/escalas">
          <Escalas />
        </Route> */}

        <Route path="/escalas-emt">
          <EscalasEMT />
        </Route>

        <Route path="/hoja-registro-emt">
          <HojaRegistroEMT />
        </Route>


        {/* Scales Routes just like anonymous */}
        <Route path="/ketamina_public/:idmedico/:idpaciente/:key">
          <KetaminaPublic />
        </Route>
        <Route path="/dolor_public/:idmedico/:idpaciente/:key">
          <HeadachePublic />
        </Route>
        <Route path="/depresion_qids_public/:idmedico/:idpaciente/:key">
          <DepresionQidsPublic />
        </Route>
        <Route path="/depresion_gpc_public/:idmedico/:idpaciente/:key">
          <DepresionEspanolPublic />
        </Route>
        <Route path="/post_traumatico_public/:idmedico/:idpaciente/:key">
          <PostTraumaticoPublic />
        </Route>
        <Route path="/post_traumatico_clinico_public/:idmedico/:idpaciente/:key">
          <PostTraumaticoClinicoPublic />
        </Route>
        <Route path="/post_traumatico_mx_public/:idmedico/:idpaciente/:key">
          <PostTraumaticoMX />
        </Route>

        {/* End of Scales Routes just like anonymous */}


        <Route path="/">
          {/* <MainPacientes /> */}
          <Home />
        </Route>

      </Switch>

      <Footer />
    </Router>
  )
}
